import styled from 'styled-components';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { theme } from '../../styles/theme';
import TableContainer from '@material-ui/core/TableContainer';

const { mainColor, secondaryColor } = theme.colors;

export const TableComponent = styled(Table)`
  padding: ${(props) => props.padding || 0};
`;

export const Header = styled(TableRow)`
  background-color: #707070;
  .MuiTableCell-head {
    color: white !important;
    font-family: Poppins;
    font-size: 0.972vw;
    font-style: normal;
    font-weight: 600;
    line-height: 1.458vw;
    letter-spacing: 0.1px;
  }
`;

export const Collum = styled(TableCell)`
  font-family: Poppins;
  font-size: 0.972vw;
  font-style: normal;
  font-weight: 400;
  line-height: 1.458vw;
  letter-spacing: 0.1px;
  width: ${(props) => props.width || 'auto'};
  max-width: ${(props) => props.width || 'initial'};
  word-wrap: break-word;
`;

export const Container = styled(TableContainer)`
  width: ${(props) => props.width || 'auto'};
  .MuiPaper-elevation1 {
    box-shadow: none;
  }
  .MuiPaginationItem-page.Mui-selected {
    color: black !important;
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1vw;
`;

export const Row = styled(TableRow)`
  :hover {
    cursor: ${(props) => props.cursor};
    background-color: rgba(255, 85, 126, 0.18);
  }
`;
